export default {
  key: 'sementsreitur',
  basepath: '/lodir/sementsreitur',
  image: {
    src: require('images/lodir/sementsreitur/I-DJI_0142.jpg'),
    width: 5272,
    height: 2962,
  },
  afangar: [
    require('./afangi-ab.js').default,
    require('./afangi-cde.js').default,
    require('./afangi-f.js').default,
    require('./afangi-ghij.js').default,
  ],
}
